import { styled } from '@mui/material/styles';

export const StyledMediaContainerDiv = styled('div')<{
  height: number;
  width: number;
  position?: React.CSSProperties['position'];
}>`
  display: grid;
  justify-items: center;
  align-content: center;

  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  position: ${({ position }) => (position ? position : 'relative')};
  background: ${({ theme }) => theme.palette.background.boxLight};
`;
